var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Feature, Layer } from 'react-mapbox-gl';
import * as React from 'react';
var LINE_LAYOUT = {
    'line-join': 'round',
    'line-cap': 'round',
};
var LINE_PAINT = {
    'line-color': {
        type: 'identity',
        property: 'color',
    },
    'line-width': 4,
};
var filterLocation = function (testEvent) {
    return testEvent.event.type === 'location';
};
var mapToCoordinates = function (testEvent) {
    var coordinates = testEvent.event.payload;
    return [coordinates.longitude, coordinates.latitude];
};
var TestLine = /** @class */ (function (_super) {
    __extends(TestLine, _super);
    function TestLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TestLine.prototype.render = function () {
        var _a = this.props, testEvents = _a.testEvents, lastOffset = _a.lastOffset;
        var past = testEvents.filter(function (value) { return filterLocation(value) && value.offset <= lastOffset; }).map(mapToCoordinates);
        var future = testEvents.filter(function (value) { return filterLocation(value) && value.offset >= lastOffset; }).map(mapToCoordinates);
        return (React.createElement(Layer, { type: "line", id: "testCaseLine", before: "shape", layout: LINE_LAYOUT, paint: LINE_PAINT },
            React.createElement(Feature, { coordinates: past, properties: { color: '#7CFC00' } }),
            React.createElement(Feature, { coordinates: future, properties: { color: '#458B00' } })));
    };
    return TestLine;
}(React.PureComponent));
export default TestLine;



//////////////////
// WEBPACK FOOTER
// ./src/components/MapControl/TestLine.tsx
// module id = 1772
// module chunks = 0